import type { ReactNode } from 'react'

interface StatTileProps {
  label: string
  value: ReactNode
  tone?: 'default' | 'primary' | 'success' | 'warning' | 'danger'
  hint?: string
  /** When set, the tile is a button that activates this handler. */
  onClick?: () => void
  active?: boolean
}

export function StatTile({
  label,
  value,
  tone = 'default',
  hint,
  onClick,
  active = false,
}: StatTileProps) {
  const className = `stat-tile stat-tile--${tone}${onClick ? ' stat-tile--interactive' : ''}${
    active ? ' stat-tile--active' : ''
  }`

  if (onClick) {
    return (
      <button
        type="button"
        className={className}
        title={hint}
        onClick={onClick}
        aria-pressed={active}
      >
        <span className="stat-tile__label">{label}</span>
        <span className="stat-tile__value">{value}</span>
      </button>
    )
  }

  return (
    <div className={className} title={hint}>
      <span className="stat-tile__label">{label}</span>
      <span className="stat-tile__value">{value}</span>
    </div>
  )
}
